import React, { useEffect } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { storefrontI18n, resetDocumentLangDir, syncDocumentLangDir, STOREFRONT_LOCALE_KEY } from './storefrontI18n';

const DocumentLangSync: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    syncDocumentLangDir(i18n.language);
    const handler = (lng: string) => {
      syncDocumentLangDir(lng);
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(STOREFRONT_LOCALE_KEY, lng);
      }
    };
    i18n.on('languageChanged', handler);
    return () => {
      i18n.off('languageChanged', handler);
    };
  }, [i18n]);

  useEffect(() => {
    return () => {
      resetDocumentLangDir();
    };
  }, []);

  return null;
};

export const StorefrontI18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <I18nextProvider i18n={storefrontI18n}>
    <DocumentLangSync />
    {children}
  </I18nextProvider>
);
